<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 30vw">
      <div class="modal-header">
        <h5 class="modal-title">💰 Deposit Funds</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label>Deposit Amount (Ksh):</label>
          <input type="number" v-model="amount" placeholder="Enter amount" />
        </div>

        <div class="form-group">
          <label>Note (optional):</label>
          <textarea
            v-model="note"
            rows="3"
            placeholder="Remarks or note"
          ></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="action-button" @click="submitDeposit">
          Deposit
        </button>
        <button type="button" class="cancel-button" @click="closeModal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "DepositModal",
  props: {
    account_id: {
      type: String,
      required: true,
    },
    transaction_details: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      amount: "",
      note: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-deposit-modal");
    },
    async submitDeposit() {
      if (!this.amount || this.amount <= 0) {
        alert("Please enter a valid deposit amount.");
        return;
      }

      var req_body = {
        account_id: this.account_id,
        amount: this.amount,
        description: this.transaction_details,
        user_note: this.note,
      };
      const url = `company-accounts/deposit`;
      await generalApiRequest(url, "POST", req_body, 1);

      // Close modal
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 50%;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

input[type="number"],
textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.action-button {
  padding: 10px 20px;
  background: #009688;
  border: none;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
}

.action-button:hover {
  background: #00796b;
}

.cancel-button {
  padding: 10px 20px;
  background: #e53935;
  border: none;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button:hover {
  background: #c62828;
}
</style>
